import React from "react";

// The dashboard's own icon set (public/dashboard/icons/*.svg). Dark-green line icons are drawn as a mask, so they take the colour of the
// text around them (white in the sidebar, navy on cards). The few coloured ones (support, time, streak, notifications) keep their colours
// unless `mono` is passed.
const BASE = `${process.env.PUBLIC_URL || ""}/dashboard/icons/`;
const COLOURED = new Set();   // the supplied set is single-colour line art: every icon takes the colour of its surroundings

export default function SvgIcon({ name, size, className = "", style, mono = false }) {
  const url = `${BASE}${name}.svg`;
  const box = size ? { width: size, height: size } : null;
  if (COLOURED.has(name) && !mono) {
    return <img src={url} alt="" aria-hidden="true" className={`svgi-img ${className}`} style={{ ...box, ...style }} />;
  }
  return <span className={`svgi ${className}`} aria-hidden="true" style={{ "--i": `url(${url})`, ...box, ...style }} />;
}
